import React, { memo } from 'react';

import { Box } from '@mui/material';
import DocumentView from 'app/shared/components/document/DocumentView';
import PropTypes from 'prop-types';

import { PreviewStatus } from '../../previewGeneration.constants';
import { PreviewStepTestIds } from '../../PreviewStep.testIds';
import PreviewGeneratingOverlay from '../PreviewGeneratingOverlay';
import PreviewStatusMessage from '../PreviewStatusMessage';

import { documentWrapperStyles, paneStyles } from './PreviewDocumentPane.styles';

const PreviewDocumentPane = ({ status, progress, errorMessage, getDocumentCall, onRetry }) => {
  if (status === PreviewStatus.ERROR || status === PreviewStatus.UNAVAILABLE) {
    return (
      <Box data-testid={PreviewStepTestIds.DOCUMENT_PANE} sx={paneStyles}>
        <PreviewStatusMessage
          errorMessage={errorMessage}
          isError={status === PreviewStatus.ERROR}
          onRetry={onRetry}
        />
      </Box>
    );
  }

  if (status !== PreviewStatus.READY) {
    return (
      <Box data-testid={PreviewStepTestIds.DOCUMENT_PANE} sx={paneStyles}>
        <PreviewGeneratingOverlay progress={progress} />
      </Box>
    );
  }

  return (
    <Box data-testid={PreviewStepTestIds.DOCUMENT_PANE} sx={paneStyles}>
      <Box sx={documentWrapperStyles}>
        <DocumentView
          isDownloadable
          isThumbnailsVisible
          isView
          supressErrorMessage
          docId="disclosure-le-preview"
          getDocumentCall={getDocumentCall}
          isControlVisible={false}
          isPrintable={false}
        />
      </Box>
    </Box>
  );
};

PreviewDocumentPane.propTypes = {
  status: PropTypes.string.isRequired,
  getDocumentCall: PropTypes.func.isRequired,
  progress: PropTypes.number,
  errorMessage: PropTypes.string,
  onRetry: PropTypes.func,
};

export default memo(PreviewDocumentPane);
